import { Component, OnInit, ViewChild } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

import SwiperCore, { SwiperOptions, Navigation, Pagination, Scrollbar, A11y, Autoplay, EffectFade, Virtual } from 'swiper';
import { SwiperComponent } from "swiper/angular";

// install Swiper modules
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay, EffectFade, Virtual]);

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.scss']
})

export class HomepageComponent  {
  public constructor(private titleService: Title, private meta: Meta) {
    this.titleService.setTitle('M|Catering - Michigan Catering Home')
    this.meta.updateTag({
      name: 'description',
      content: 'Enjoy delicious food and excellent service at your next one-of-a-kind event. Serving Ann Arbor and Southeast Michigan.'
    });
    this.meta.updateTag({
      name: 'og:title',
      content: 'Michigan Catering'
    });
    this.meta.updateTag({
      name: 'og:description',
      content: 'Enjoy delicious food and excellent service at your next one-of-a-kind event. Serving Ann Arbor and Southeast Michigan.'
    });
  }
  @ViewChild('swiper', { static: false }) swiper!: SwiperComponent;
  @ViewChild('testimonials', { static: false }) testimonials!: SwiperComponent;


  autoplayPause = false;

  config: SwiperOptions = {
    slidesPerView: 1,
    autoplay: {
      delay: 3000,
    },
    loop: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
  };
  testimonialsConfig: SwiperOptions = {
    loop: true,
    slidesPerView: 1,
    a11y: {
     prevSlideMessage: 'Previous slide',
     nextSlideMessage: 'Next slide',
    },
    navigation: {
     nextEl: '.next',
     prevEl: '.prev',
   },
  };

  toggleAutoplay() {
    if(this.swiper.swiperRef.autoplay.running) {
      this.swiper.swiperRef.autoplay.stop();
      this.autoplayPause = true;
    } else {
      this.swiper.swiperRef.autoplay.start();
      this.autoplayPause = false;
    }
  }

}
